<p tabindex="0">
  <i class="fas fa-exclamation-circle"></i>
  <span>
    {{ message }}
  </span>
</p>

